import * as React from "react";
import { Feature, featureEnabled } from "./client-features";
import { User } from "./client/types.gen";
import { useClientId } from "./ClientConfig";

export const useFeatureEnabled = (
  feature: Feature,
  lob?: string,
  user?: User
): boolean => {
  return featureEnabled(useClientId(), feature, { lob, user });
};

export const IfFeatureEnabled: React.FC<{
  feature: Feature;
  lob?: string;
  user?: User;
  children: React.ReactNode;
}> = ({ feature, lob, user, children }) => {
  return useFeatureEnabled(feature, lob, user) ? children : null;
};

export const IfFeatureDisabled: React.FC<{
  feature: Feature;
  lob?: string;
  user?: User;
  children: React.ReactNode;
}> = ({ feature, lob, user, children }) => {
  return useFeatureEnabled(feature, lob, user) ? null : children;
};
